/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';
import { AdminConfigType } from './admin-config-type.get';

export const AdminConfigTypePatch = {
  id: 'admin-config-type.patch',
  tag: 'Admin',
  summary: 'Patch admin config',
  description: 'Update admin config',
  method: 'patch',
  flags: { isAuthorized: true },
  route: () => `/administration/config/jira`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            atlassianUrl: z.string(),
            serviceDeskKey: z.string(),
            email: z.string(),
            token: z.string(),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: AdminConfigType.response['200'].content['application/json'].schema,
        },
      },
    },
  },
} as const satisfies Endpoint;
